import styled from 'styled-components';

export const ErrorText = styled.div`
  text-align: center;
  color: ${(props) => props.theme.colors.elements.warning};
  padding: 1em 0;
`;
